module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "request-subjects text-dark"
  }, [_vm._m(0), _vm._v(" "), (_vm.isLoading || _vm.isLoadingSubjectsRequests) ? _c('Loader') : _c('div', {
    staticClass: "request-subjects-grid"
  }, [_c('RequestSubjectsUser', {
    attrs: {
      "user": _vm.user,
      "userSubjects": _vm.userRequestedSubjectsWithProps,
      "allCalendarsInHash": _vm.allCalendarsInHash,
      "loadingSubjects": _vm.loadingSubjects
    },
    on: {
      "removeSubject": function($event) {
        return _vm.onSetSubjectRequest($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "doTable"
  }, [_c('div', {
    staticClass: "subject-dist__header"
  }, [_c('div', {
    staticClass: "subject-dist__header__left"
  }, [(_vm.selectedTab === 'Fag') ? _c('DoFiltersFilter', {
    attrs: {
      "title": 'Klasser',
      "tags": _vm.klassTags,
      "selectedTags": _vm.selectedKlassFilters
    },
    on: {
      "select": _vm.toggleKlassTag,
      "clear": function($event) {
        _vm.selectedKlassFilters = []
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'Fag') ? _c('DoFiltersFilter', {
    attrs: {
      "title": 'Status på fag',
      "tags": _vm.statusFilters,
      "selectedTags": _vm.selectedStatusFilters
    },
    on: {
      "select": _vm.toggleSelectedStatusFilters,
      "clear": function($event) {
        _vm.selectedStatusFilters = []
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.selectedTab === 'Opgaver') ? _c('table', {
    staticClass: "do-table do-table__tasks"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th', {
    staticClass: "td-number"
  }, [_vm._v("Timer")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tasks), function(task) {
    return _c('tr', {
      key: task.id
    }, [_c('td', [_c('button', {
      staticClass: "do-bttn do-bttn--request-subject marg-1-right",
      on: {
        "click": function($event) {
          _vm.onSetSubjectRequest(task.id)
        }
      }
    }, [_vm._v("\n              Ønsk\n            ")]), _vm._v("\n            " + _vm._s(task.name) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "td-number"
    }, [_vm._v(_vm._s(task.hours))])])
  }), 0)]) : _c('ul', {
    staticClass: "doTable__items"
  }, _vm._l((_vm.filteredKlassCals), function(klassCal, idx) {
    return _c('li', {
      key: klassCal.id,
      staticClass: "doTable__klass"
    }, [_c('div', {
      staticClass: "doTable__klass__header"
    }, [_c('div', [_vm._v(_vm._s(klassCal.name))])]), _vm._v(" "), _c('ul', {
      staticClass: "subjects"
    }, _vm._l((klassCal.vSubjects), function(subject) {
      return _c('li', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            arrow: true,
            onShow: function () { return subject.vRequestedBy.length > 0 || subject.vHasTeachers; }
          }),
          expression: "{\n          arrow: true,\n          onShow: () => subject.vRequestedBy.length > 0 || subject.vHasTeachers\n        }"
        }],
        key: subject.id,
        staticClass: "subjects_subject",
        class: [{
          'subject--has-user': subject.vRequestedBy.length > 0
        }],
        style: ({
          'background': subject.color
        }),
        attrs: {
          "content": !subject.vHasTeachers ? 'Ønsket af ' + subject.vRequestedBy : subject.vUserNames + ' er valgt'
        }
      }, [_vm._v("\n\n              " + _vm._s(subject.name) + " (" + _vm._s(subject.hours) + ")\n              "), (!subject.vHasTeachers) ? _c('button', {
        staticClass: "do-bttn do-bttn--request-subject",
        class: {
          'do-bttn--remove': subject.vIsRequestedByUser
        },
        on: {
          "click": function($event) {
            return _vm.onSetSubjectRequest(subject.id)
          }
        }
      }, [(subject.vIsLoading) ? _c('div', {
        staticClass: "do-spinner do-spinner__small"
      }) : [_vm._v("\n                  " + _vm._s(subject.vIsRequestedByUser ? 'Fjern ønske' : 'Ønsk') + "\n                ")]], 2) : _vm._e()])
    }), 0)])
  }), 0)])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "request-subjects__header"
  }, [_c('h1', [_vm._v("Ønsker til fagfordelingen")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1c8bdc89!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubjectsDistribution/RequestSubjects.vue
// module id = 1494
// module chunks = 1